import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'

type Props = {
  title?: string
}

const WaitComponent = (props: Props) => {
  return (
    <>
      <LinearProgress color="secondary" />
      {props.title ? <div>{props.title}</div> : null}
    </>
  )
}

export default WaitComponent
